import { APP_LOGO_MAP } from "../constants/appLogoMap";
import { IApp } from "../types/app";


export class AppModel {
  private app: IApp;
  
  constructor(app: IApp) {
    this.app = { ...app };
  }

  public getValue() {
    return this.app;
  }

  public updateApp(app: IApp) {
    this.app = { ...app };
  }

  public getIcon(appId: string) {
    return APP_LOGO_MAP[appId];
  }

  public setBookmarked(bookmarked: boolean) {
    this.app = { ...this.app, bookmarked };
    return bookmarked;
  }

  public toggleBookmark() {
    this.setBookmarked(!this.app.bookmarked);
  }
}
